import { UntypedFormGroup } from '@angular/forms';
import {
  FormItems
} from 'app/domain/payment-domain/ui-commons/page-info-billing/ui-commons/presenter/page_userinfo.presentert';

export class ReactiveFormHelper {
  constructor(
    private form: UntypedFormGroup,
    private formItems: FormItems
  ) { }

  getErrors(controlName: string): string | null {
    let error = null;
    const fieldErrors = this.form.controls[controlName].errors;
    const mapperError = this.formItems[controlName].errors;
    const isDirty = this.form.controls[controlName].dirty;
    if (fieldErrors && mapperError && isDirty) {
      Object.keys(fieldErrors).forEach((key) => {
        //@ts-expect-error: Unreachable code error
        if (mapperError[key]) {
          //@ts-expect-error: Unreachable code error
          error = mapperError[key];
        }
      });
    }

    return error;
  }
}
